import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { toggleSidebarAction } from "../../../store/actions/actionCreators/commonActionCreator";
import HeaderProfile from "../../Home/HeaderProfile/HeaderProfile";
import Logo from "../Logo/Logo";
import HamburgerIocn from "../SvgIcons/HeaderIcons/HamburgerIcon";
import profileImg from "../../../assets/images/Common/profileImg.svg";
import HelpIcon from "../SvgIcons/HeaderIcons/HelpIcon";
import ProfilePic from "../SvgIcons/HeaderIcons/ProfilePic";
import classes from "./Header.module.scss";
import useComponentVisible from "../../../hooks/useComponentVisible";
import LangChange from "../LangChange/LangChange";
import Tooltip from "../ToolTip/Tooltip";
import setAndGetLocalLang from "../../../utils/setAndGetLocalLang";

const Header = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const commonState = useSelector((state) => state.commonReducer);
  const { isSidebarExapand } = commonState;
  const profile = useSelector((state) => state.commonReducer);
  const { myProfile } = profile;
  const handleClick = () => {
    dispatch(toggleSidebarAction(!isSidebarExapand));
  };

  const { LogoImage, PaneColor, PrimaryColor1 } = JSON.parse(
    localStorage.getItem("themeData")
  ).CustomData;
  const isDarkTheme = JSON.parse(
    localStorage.getItem("themeData")
  )?.IsDarkHeaderRequired;
  const logoDimesnion = {
    // width: "150px",
    // height: "60px",
    logoImage: LogoImage,
    altText: "Logo Text is missing",
  };
  const [ref, isComponentVisible, setIsComponentVisible] =
    useComponentVisible();

  const headerProfileonClick = (e) => {
    // e.stopPropagation();
    setIsComponentVisible(!isComponentVisible);
  };
  const handleNavigateHome = () => {
    navigate(`home`);
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  };
  useEffect(() => {
    const tenantType =
      localStorage.getItem("SecurityProviderName") == "aad" ||
      localStorage.getItem("SecurityProviderName") == "SAML2";
    if (tenantType) {
      if (
        localStorage.getItem("languageTerm") === null ||
        localStorage.getItem("language") === null
      ) {
        setAndGetLocalLang("en-GB", "English", dispatch);
      }
    }
  }, [dispatch]);
  useEffect(() => {
    const languageTerm = localStorage.getItem("languageTerm");
    const language = localStorage.getItem("language");
    if (languageTerm !== "undefined" && language !== "undefined") {
      setAndGetLocalLang(languageTerm, language, dispatch);
    }
  }, [dispatch, setAndGetLocalLang]);
  return (
    <header
      className={
        isDarkTheme
          ? classes.header + " " + classes.headerDark
          : classes.header
      }
    >
      <div className={classes.headerLeft}>
        <span className={classes.logoNavigate} onClick={handleNavigateHome}>
          <Logo logoDimesnion={logoDimesnion} />
        </span>
        <div className={classes.hamburgerIcon} onClick={handleClick}>
          <HamburgerIocn fill={isDarkTheme ? "#fff" : PrimaryColor1} />
        </div>
      </div>
      <div className={classes.headerRight}>
        <LangChange />
        <div
          className={classes.profilePic}
          onClick={(e) => {
            e.stopPropagation();
            headerProfileonClick();
          }}
        >
          {/* {myProfile?.ProfileImageUrl === null ? ( */}
          <img
            src={
              myProfile?.ProfileImageUrl === "Profil" ||
              myProfile?.ProfileImageUrl === "" ||
              myProfile?.ProfileImageUrl === null
                ? profileImg
                : myProfile?.ProfileImageUrl
            }
            onError={(e) => {
              e.target.onerror = null;
              e.target.src = profileImg;
            }}
            alt="profile"
          />
          {/* // ) : (
          //   <Loader height={"30%"} width={"30%"} />
          // )} */}

          {/* <ProfilePic border={`0.1rem solid ${PrimaryColor1}`}/> */}
        </div>
        {isComponentVisible ? (
          <HeaderProfile
            reference={ref}
            headerProfileonClick={headerProfileonClick}
          />
        ) : (
          // <div style={{backgroundColor: "red", width: "40rem",height: "40rem", top: "40rem",position: "absolute"}}>hello</div>
          <></>
        )}
        <Tooltip content={"Help"} direction="bottom">
          <a href="https://helppage.azurewebsites.net/Default" target="_blank">
            <HelpIcon fill={isDarkTheme ? "#fff" : "#000"} stroke={isDarkTheme && "#fff"} />
          </a>
        </Tooltip>
      </div>
    </header>
  );
};

export default Header;
